import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

const CREATE_CHAT_SESSION_MUTATION = gql`
  mutation createChatSession {
    createChatSession {
      id
      title
      createdAt
      updatedAt
      user {
        id
      }
    }
  }
`;

export const useCreateChatSession = () => {
  const [createChatSessionMutation] = useMutation(CREATE_CHAT_SESSION_MUTATION, {
    errorPolicy: 'all',
  });

  const createSession = useCallback(
    async () => await createChatSessionMutation(),
    [createChatSessionMutation],
  );

  return createSession;
};
